<template>

<a :href="item.download" target="_blank" class="event">

    <div class="event-label" v-if="label">{{ label }}</div>

	<div class="event-image" :style="{backgroundImage: $util.thumbnail(item.image)}"></div>

	<div class="event-text">
        
        <div class="event-text-name">{{ item.name }}</div>
        <div class="event-text-date">{{ item.date | formatDate('Do MMMM YYYY') }}</div>
    
    </div>

</a>

</template>

<script>

export default {

    props: ['item', 'hideBusiness', 'label']

}

</script>

<style scoped>

.event {
	display: block;
	border-radius: 4px;
	width: 240px;
	margin: 20px;
	display: flex;
    cursor: pointer;
	flex-shrink: 0;
	flex-direction: column;
    overflow: hidden;
}

.is-mobile .event {
    width: 150px;
    margin: 4px;
}

.event-label {
    position: absolute;
    z-index: 2;
    background-color: var(--color-yellow);
    color: #fff;
    font-size: 14px;
    height: 20px;
    line-height: 20px;
    font-weight: 300;
    width: 120px;
    text-align: center;
    left: -40px;
    top: 10px;
    transform: rotate(-45deg);
}

.event-image {
	height: 200px;
	background-color: #eee;
	background-position: 50% 50%;
	background-size: cover;
    border-radius: 4px 4px 0px 0px;
}

.is-mobile .event-image {
    height: 120px;
}

.event-text {
	border: 1px solid var(--color-grey-light);
	padding: 10px;
    border-top-width: 0px;
    border-radius: 0px 0px 4px 4px;
    background-color: #fff;
}

.is-desktop .event:hover .event-text {
	border-color: var(--color-grey-highlight);
}

.event-text-name {
	font-size: 14px;
	font-weight: 700;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	color: var(--color-grey-dark);
}

.event-text-date {
	margin-top: 5px;
	font-size: 12px;
	font-weight: 300;
	overflow: hidden;
	color: var(--color-grey-dark);
	text-overflow: ellipsis;
	white-space: nowrap;
}

</style>